import React, { Component as C } from "react"
import PropTypes from "prop-types"

import Button from "../../buttons/button/index.jsx"
import Cropper from "react-cropper"
import styles from "./styles.less"

require("cropperjs/dist/cropper.css")

class ImageCropper extends C {
  constructor(props) {
    super(props)
    this.state = { cropData: null }
  }

  static propTypes = {
    onImageLoad: PropTypes.func.isRequired,
    imageUrl: PropTypes.string,
    styles: PropTypes.object,
    aspectRatio: PropTypes.number,
    previewSelector: PropTypes.string,
    zoomOnWheel: PropTypes.bool,
    uploadButtonText: PropTypes.string,
    onUploadFailed: PropTypes.func,
  }

  static defaultProps = {
    onImageLoad: null,
    imageUrl: null,
    styles: { height: 500, width: 500 },
    aspectRatio: 16 / 9,
    previewSelector: null,
    zoomOnWheel: true,
    uploadButtonText: "Upload image",
    onUploadFailed: null,
  }

  _handleImageChange(e) {
    e.preventDefault()

    let reader = new FileReader()
    let file = e.target.files[0]

    if (!file.type.match("image.*")) {
      if (typeof this.props.onUploadFailed === "function") this.props.onUploadFailed()

      return
    }

    reader.onloadend = () => {
      this.props.onImageLoad({
        imageUrl: reader.result,
      })
    }

    reader.readAsDataURL(file)
  }

  render() {
    return (
      <div>
        <Button type="success" className={styles.fileButton} controlType="link">
          <div className={styles.buttonContent}>
            <span>{this.props.uploadButtonText}</span>
            <input
              className={styles.input}
              type="file"
              onChange={(e) => this._handleImageChange(e)}
            />
          </div>
        </Button>
        {this.props.imageUrl ? (
          <Cropper
            ref="cropper"
            src={this.props.imageUrl}
            style={this.props.styles}
            aspectRatio={this.props.aspectRatio}
            guides={false}
            preview={this.props.previewSelector}
            zoomOnWheel={this.props.zoomOnWheel}
          />
        ) : null}
      </div>
    )
  }
}

export default ImageCropper
